import React from 'react';
import {LayoutContext} from '../ProductPageApp/ProductPageApp';
import s from './ProductDiscountName.scss';

export interface ProductDiscountNameProps {
  name: string;
}

export class ProductDiscountName extends React.Component<ProductDiscountNameProps> {
  public render(): JSX.Element {
    return (
      <LayoutContext.Consumer>
        {() => (
          <p data-hook="product-discount-name" className={s.productDiscountName}>
            {this.props.name}
          </p>
        )}
      </LayoutContext.Consumer>
    );
  }
}
